<template>
  <div style="width: 100%; height: 100%">
    <img v-if="switchhost == 'true'" :src='xiaomaolvHello'/>
    <img v-if="switchhost == 'false'" :src='duoduoHello'/>
  </div>
</template>
<script>
export default {
  data() {
    return {
      switchhost: "",
      xiaomaolvHello: require('../../static/imgs/xiaomaolvhello.png'),
      duoduoHello: require('../../static/imgs/duoduohello.png')
    };
  },

  created() {},
  mounted() {
    this.switchhost = localStorage.getItem("total_switchhost");
  },
  methods: {},
};
</script>
<style scoped>
img {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/helloPage.vue